import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaCustomizations from './media-customizations-model'
import {
  delete_mediaCustomizations,
  load_mediaCustomizationss,
  store_mediaCustomizations,
} from './mediaCustomizations-service'

export const LoadMediaCustomizationssAsync = createAsyncThunk<any, any>(
  'composer/load/mediaCustomizations',
  async (params: { uid: string }) => {
    return await load_mediaCustomizationss(params)
  },
)

export const CreateMediaCustomizationsAsync = createAsyncThunk<any, any>(
  'composer/create/mediaCustomizations',
  async (params: MediaCustomizations) => {
    return await store_mediaCustomizations(params)
  },
)

export const DeleteMediaCustomizationsAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaCustomizations',
  async (params) => {
    return await delete_mediaCustomizations(params)
  },
)
